import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import NodataAvailable from "../../../../../Common/NodataAvailable";
import { serverInfo } from "../../../../../../App";

const FanYoursGroup = () => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [useFanGroup, setFanUserGroup] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    localStorage.getItem("auth_token") &&
      axios.get(`/api/user/fan/group/list`).then((res) => {
        setLoading(false);
        if (res.data.status === 200) {
          setFanUserGroup(res.data.useFanGroup);
        }
      });
  }, []);

  return (
    <>
      <div className="row mx-1 justify-content-between ">
        <h2 className="my-3 text-dark fw-bold activitiesBg p-2 btn w-100 text-center">
          Already Enrolled
        </h2>

        {loading ? (
          <SkeletonTheme baseColor="#202020" highlightColor="#444">
            <div className="row">
              {[1, 2].map((data) => (
                <div className="col-md-6 mb-4 ">
                  <div className="rounded">
                    <div className="bg-dark py-3 px-2">
                      <Skeleton width="100%" height={150} />
                      <Skeleton width="20%" height={15} />
                      <Skeleton width="100%" className="" height={25} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </SkeletonTheme>
        ) : (
          <>
            {useFanGroup.length === 0 ? (
              <NodataAvailable />
            ) : (
              <>
                {useFanGroup.map((fan, index) => (
                  <div className="YourGroups col-md-6 pb-3">
                    <img
                      src={imageCdnUrl + fan?.fangroup?.banner}
                      className="YoursImg img-fluid"
                      alt=""
                    />

                    <Link to={`group/${fan.fangroup.id}`}>
                      <div
                        className={`d-flex justify-content-center ${
                          index % 2 === 0 ? "bg-danger" : "bg-success"
                        } p-3`}
                      >
                        <div className="celebratePerallal text-dark">
                          {fan.fangroup.group_name}
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </>
            )}
          </>
        )}

        {/* )} */}
      </div>
    </>
  );
};

export default FanYoursGroup;
